/* Şəkli yükləməzdən əvvəl kiçildir.
 *
 * Telefon kamerası 8-12 MB-lıq şəkil çıxarır; şəxsiyyət vəsiqəsini oxumaq
 * üçün bu qədər böyüklük lazım deyil və yüklənmə həm yavaş gedir, həm də
 * server həddini aşıb "xəta baş verdi" ilə dayanırdı.
 *
 * Uzun tərəf MAX_SIDE-dək kiçildilir, JPEG keyfiyyəti 0.85 götürülür —
 * vəsiqədəki mətn tam oxunaqlı qalır, ölçü isə adətən 10 dəfədən çox azalır.
 * Şəkil deyilsə (PDF), kiçikdirsə və ya emal alınmasa, fayl olduğu kimi
 * qaytarılır — yükləmə heç vaxt bu addıma görə dayanmır.
 */
const MAX_SIDE = 2200;
const QUALITY = 0.85;
const SKIP_UNDER = 900 * 1024;   // 900 KB-dan kiçik şəklə toxunmuruq

export default function shrinkImage(file) {
  return new Promise((resolve) => {
    if (!file || !file.type || !file.type.startsWith('image/')) return resolve(file);
    if (file.type === 'image/gif') return resolve(file);
    if (file.size <= SKIP_UNDER) return resolve(file);

    const url = URL.createObjectURL(file);
    const img = new Image();

    const done = (result) => { URL.revokeObjectURL(url); resolve(result || file); };

    img.onerror = () => done(null);
    img.onload = () => {
      try {
        const scale = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
        const w = Math.round(img.width * scale);
        const h = Math.round(img.height * scale);

        // Kiçiltməyə ehtiyac yoxdursa və fayl artıq JPEG-dirsə, toxunmuruq
        if (scale === 1 && file.type === 'image/jpeg') return done(null);

        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = '#fff';           // şəffaf PNG qara çıxmasın
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0, w, h);

        canvas.toBlob((blob) => {
          // Nəticə orijinaldan böyükdürsə, orijinalı saxlayırıq
          if (!blob || blob.size >= file.size) return done(null);
          const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
          done(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() }));
        }, 'image/jpeg', QUALITY);
      } catch {
        done(null);
      }
    };

    img.src = url;
  });
}
